module.exports = __webpack_public_path__ + "img/icon_logo_cn@3x.953423cd.png";